var _g, _rect, _g2, _rect2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 116,
    viewBox: "0 0 226 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 40.3616,
    width: 80,
    height: 80,
    rx: 12,
    transform: "rotate(-20 0 40.3616)",
    fill: "url(#paint0_linear_9_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0208 120.348L71.5074 59.827C73.1185 54.5527 79.4575 52.452 83.8996 55.7203L132.446 91.4394L53.0208 120.348Z",
    fill: "#6CA9EA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13745 140.294L27.344 61.0482C28.9551 55.7739 35.2941 53.6732 39.7361 56.9416L103.416 103.795L3.13745 140.294Z",
    fill: "url(#paint1_linear_9_49)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.2499,
    cy: 34.5825,
    r: 6.27871,
    transform: "rotate(-20 63.2499 34.5825)",
    fill: "#6CA9EA"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92257,
    y: 41.2581,
    width: 77,
    height: 77,
    rx: 10.5,
    transform: "rotate(-20 1.92257 41.2581)",
    stroke: "#E1E1E1",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.898,
    y: 13,
    width: 80,
    height: 80,
    rx: 12,
    transform: "rotate(20 149.898 13)",
    fill: "url(#paint2_linear_9_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.101 108.354L192.164 73.8754C196.789 70.8707 202.995 73.3361 204.297 78.6951L218.526 137.262L139.101 108.354Z",
    fill: "#6CA9EA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0667 91.5691L157.548 46.4232C162.172 43.4185 168.379 45.8839 169.681 51.2429L188.345 128.067L88.0667 91.5691Z",
    fill: "url(#paint3_linear_9_49)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.065,
    cy: 49.2292,
    r: 6.27871,
    transform: "rotate(20 202.065 49.2292)",
    fill: "#6CA9EA"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150.795,
    y: 14.9226,
    width: 77,
    height: 77,
    rx: 10.5,
    transform: "rotate(20 150.795 14.9226)",
    stroke: "#E1E1E1",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_49)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 3,
    width: 80,
    height: 80,
    rx: 12,
    fill: "url(#paint4_linear_9_49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4663 96.2966L132.537 45.7485C135.855 41.3433 142.53 41.5374 145.587 46.1279L178.989 96.2966H94.4663Z",
    fill: "#6CA9EA",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7695 97.9785L90.6198 31.7913C93.9376 27.3861 100.613 27.5802 103.669 32.1707L147.484 97.9785H40.7695Z",
    fill: "url(#paint5_linear_9_49)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.412,
    cy: 19.2022,
    r: 6.27871,
    fill: "#6CA9EA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 4.5,
    width: 77,
    height: 77,
    rx: 10.5,
    stroke: "#E1E1E1",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_49",
    x: 68,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_49",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_49",
    x1: 40,
    y1: 40.3616,
    x2: 40,
    y2: 120.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BCBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_49",
    x1: 27.5548,
    y1: 51.3743,
    x2: 53.2766,
    y2: 122.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CA9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_49",
    x1: 189.898,
    y1: 13,
    x2: 189.898,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BCBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_49",
    x1: 163.928,
    y1: 39.1481,
    x2: 138.206,
    y2: 109.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CA9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_49",
    x1: 112,
    y1: 3,
    x2: 112,
    y2: 83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BCBE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_49",
    x1: 94.1265,
    y1: 22.7729,
    x2: 94.1265,
    y2: 97.9785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CA9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_49"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 40.3616,
    width: 80,
    height: 80,
    rx: 12,
    transform: "rotate(-20 0 40.3616)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.898,
    y: 13,
    width: 80,
    height: 80,
    rx: 12,
    transform: "rotate(20 149.898 13)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 3,
    width: 80,
    height: 80,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCards);
export default __webpack_public_path__ + "static/media/photo-cards.45d764bf9afa2239ec5d9d29132b0395.svg";
export { ForwardRef as ReactComponent };